module.exports = __webpack_public_path__ + "static/media/A260986B-AC1F-4FB7-9C0F-2F87DD295388.00e3e359.jpeg";